import type { CampaignAdProduct } from '@/types/spCampaigns';

/** Hash target for AppShell scroll when returning to the Workspace Campaigns table. */
export const WORKSPACE_CAMPAIGNS_SECTION_ID = 'workspace-campaigns';

export function profileCampaignDetailPath(
  profileId: string,
  campaignId: string,
  adProduct: CampaignAdProduct = 'SP'
): string {
  const base = `/accounts/${encodeURIComponent(profileId)}/campaigns/${encodeURIComponent(campaignId)}`;
  if (adProduct && adProduct !== 'SP') {
    return `${base}?product=${encodeURIComponent(adProduct)}`;
  }
  return base;
}
